import { Modal } from 'ant-design-vue';
import { useAutoConvertStoreWithOut } from '/@/store/modules/auto-convert';

/**
 * 下载权限门禁：未转化试用用户不可下载。
 * @returns true 可继续下载；false 已拦截
 */
export async function checkDownloadPermission(): Promise<boolean> {
  const autoConvertStore = useAutoConvertStoreWithOut();
  try {
    await autoConvertStore.getAutoConvertInfo();
  } catch (e) {
    console.error('[checkDownloadPermission] getWebsiteAutoConvertInfo failed', e);
    // 接口失败不阻断业务
    return true;
  }

  if (autoConvertStore.isNotConverted) {
    Modal.info({
      title: null,
      icon: null,
      closable: true,
      okText: '确定',
      content: '试用会员暂不支持，可联系已添加的企微专属顾问处理',
    });
    return false;
  }

  return true;
}
